import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display"]
  static values = { ratio: Number }

  connect() {
    this.input = this.element.querySelector('input[type="number"]')
    if (this.input) {
      this.update()
      this.input.addEventListener('input', this.update.bind(this))
    }
  }

  disconnect() {
    if (this.input) {
      this.input.removeEventListener('input', this.update.bind(this))
    }
  }

  update() {
    const value = parseFloat(this.input.value || 0)
    const amount = Math.round(value * (this.ratioValue || 0))
    const formatted = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(amount)
    const percent = Math.round((this.ratioValue || 0) * 100)
    this.displayTarget.textContent = `${percent}% = ${formatted}`
  }
}
